import styled from 'styled-components';

export const ContactPersonsListContent = styled.div<{ isFirstItem: boolean; isBtn: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ isFirstItem }) =>
    isFirstItem &&
    `
    & > div:first-child {
        margin-top: 20px;
        margin-bottom: 14px;
    }
  `}
  ${({ isBtn }) =>
    isBtn &&
    `
    & > div:last-child {
      align-self: flex-end;
      .ant-btn {
        padding: 0;
      }
    }
  `}
`;

export const DeleteContainer = styled.div`
  display: flex;

  .ant-form-item {
    width: 100%;
  }

  & > div:last-child {
    margin-left: 16px;
    align-self: flex-start;
    margin-top: 33px;
    cursor: pointer;
  }
`;

export const FieldsWrapper = styled.div<{ isEdit?: boolean }>`
  & > div:first-child {
    ${({ isEdit }) =>
      isEdit &&
      `
      display: flex;

      .ant-form-item {
        width: 288px;
      }

      & > div {
        margin-right: 48px;
      }
      & > div:last-child {
         margin: 24px 0;
      }
  `}
  }
`;

export const ButtonWrapper = styled.div<{ isLast: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ isLast }) =>
    isLast &&
    `
    & > div:last-child {
      align-self: flex-end;
      .ant-btn {
        padding: 0;
      }
    }
  `}
`;
